const classNames = function classNames() {
  let str = arguments[0];
  for (let i = 1; i < arguments.length; i++) {
    str = `${str} ${arguments[i] ? arguments[i] : ''}`;
  }
  return str;
};

const classNameAndClasses = function classNameAndClasses(classes, keyName, className) {
  if (classes) {
    return classes[keyName] ? classNames(classes[keyName], className) : className;
  } else {
    return className;
  }
};

export { classNames, classNameAndClasses };
